/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styles from "./BackNextButtons.module.scss";
import { useNavigate } from "react-router-dom";

const BackNextButtons = ({
  props,
  nextOnClick,
  displayBack = true,
  isGreenButton = false
}) => {
  const navigate = useNavigate();
  const nextButtonClassName = displayBack ? styles["margin_left_20"] : "";
  return (
    <div className={styles["display_flex"]}>
      {displayBack ? (
        <div className={styles["back_center"]}>
          <a
            onClick={() => {
              try {
                navigate(props.prevURL);
              } catch (e) {
                console.log(e);
              }
            }}
            href={props.prevURL}
          >
            {props.prevText}
          </a>
        </div>
      ) : (
        ""
      )}
      <div className={nextButtonClassName}>
        <button
          className={[
            isGreenButton ? "btn-lg btn-success" : "btn-lg btn-default",
            styles["margin_zero"]
          ].join(" ")}
          onClick={nextOnClick}
          value={props.nextText}
          name={props.nextText}
        >
          {props.nextText}
        </button>
      </div>
    </div>
  );
};

export default BackNextButtons;
